<template>
  <div class="pc-news-page">
    <section class="pc-container top-news">
      <article v-for="item in topNews" :key="item.id" @click="goDetail(item)">
        <img :src="item.coverImage" :alt="item.title">
        <h2>{{ item.title }}</h2>
        <time>{{ item.publishDate }}</time>
      </article>
    </section>

    <section class="pc-container news-list">
      <div v-if="loading" class="empty">加载中...</div>
      <div v-else-if="!newsList.length" class="empty">暂无新闻</div>
      <article v-for="item in newsList" :key="item.id" class="news-row" @click="goDetail(item)">
        <div class="date-box">
          <strong>{{ item.monthDay }}</strong>
          <span>{{ item.year }}</span>
        </div>
        <div class="row-content">
          <h2>{{ item.title }}</h2>
          <p>{{ item.summary }}</p>
        </div>
      </article>
    </section>
  </div>
</template>

<script>
  import { getPcPublicNewsList } from '@/api/pc'
  import commerce from '@/utils/pcCommerce'
  import { buildPcDetailPath } from '@/utils/pcRouteCode'

  export default {
    name: 'PcNewsList',
    data() {
      return {
        loading: false,
        newsList: []
      }
    },
    computed: {
      topNews() {
        return this.newsList.filter(item => item.isTop === 1).slice(0, 3)
      }
    },
    created() {
      this.loadNews()
    },
    methods: {
      loadNews() {
        this.loading = true
        getPcPublicNewsList({ page: 1, pageSize: 20 }).then(data => {
          const records = data && data.records ? data.records : []
          this.newsList = records.map(commerce.normalizePcNews)
        }).catch(() => {
          this.newsList = []
        }).finally(() => {
          this.loading = false
        })
      },
      goDetail(item) {
        this.$router.push(buildPcDetailPath('news', item.id))
      }
    }
  }
</script>

<style scoped>
  .pc-news-page {
    min-height: calc(100vh - 206px);
    background: #fff;
    padding: 36px 0 70px;
  }

  .top-news {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 32px;
  }

  .top-news article {
    height: 264px;
    background: #f3f3f3;
    cursor: pointer;
  }

  .top-news img {
    width: 100%;
    height: 200px;
    object-fit: cover;
  }

  .top-news h2 {
    margin: 8px 10px 0;
    font-size: 15px;
    font-weight: 400;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .top-news time {
    display: block;
    margin: 14px 10px 0;
    text-align: right;
    color: #9099a8;
  }

  .news-list {
    margin-top: 20px;
    border-top: 1px solid #eee;
  }

  .news-row {
    min-height: 108px;
    display: grid;
    grid-template-columns: 150px 1fr;
    gap: 20px;
    border-bottom: 1px solid #eee;
    cursor: pointer;
  }

  .date-box {
    padding-top: 22px;
    text-align: center;
    color: #8a8f99;
  }

  .date-box strong,
  .date-box span {
    display: block;
  }

  .date-box strong {
    font-size: 22px;
    font-weight: 400;
  }

  .row-content {
    padding-top: 18px;
  }

  .row-content h2 {
    margin: 0 0 10px;
    font-size: 18px;
    font-weight: 400;
    color: #27364a;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .row-content p {
    margin: 0;
    color: #5c6678;
    line-height: 24px;
  }

  .empty {
    padding: 80px 0;
    text-align: center;
    color: #8a8f99;
  }
</style>
